import React, { Component } from "react";
import HomeTile from "../components/HomeTile";
import HomePanel from "../parts/HomePanel";
import Explore from "../assets/LOUPE_big.png";
import FAQ from "../assets/FAQ_big.png";
import { Link } from "react-router-dom";
export class Home extends Component {
  render() {
    return (
      <div id="home">
        <div id="homeTop">
          <Link to="/faq">
            {" "}
            <HomeTile text={"FAQ"} img={FAQ} />
          </Link>
          {/* <Link to="/"> <HomeTile text={"GET NFrogT"} isMainTile={true} /></Link>
                    <Link to="/"> <HomeTile text={"EXPLORE"} explore={true} img={Explore} /></Link>*/}
          {/*  <Link to="/"> <HomeTile text={"DROP IS OVER"} isMainTile={true} /></Link>*/}
          <Link to="/">
            {" "}
            <HomeTile text={"NFROGTS GAME"} isMainTile={true} />
          </Link>
          <Link to="/explore">
            {" "}
            <HomeTile text={"EXPLORE"} explore={true} img={Explore} />
          </Link>
        </div>
        {/*<div id="homeBottom">
        <HomePanel/>
                </div>*/}
      </div>
    );
  }
}

export default Home;
